import React from "react"
import styled from "styled-components"

import HeroImage from "../HeroImage"
import IoAnimator from "../IoAnimator"

const ImageTiles = ({ images }) => {
  return (
    <Container>
      {!!images && (
        <Images>
          {images.map(({ image: { alt, url: img } }, index) => {
            return (
              <Item key={index}>
                <HeroImage alt={alt} bg={img} />
              </Item>
            )
          })}
        </Images>
      )}
    </Container>
  )
}

export default ImageTiles

const Container = styled.div``
const Images = styled.div`
  @media (min-width: 800px) {
    flex-direction: row;
  }
  /* flex-direction: column; */
  display: flex;
`
const Item = styled(IoAnimator)`
  margin-left: 1px;
  margin-right: 1px;
  &:first-of-type {
    margin-left: 0px;
  }
  &:last-of-type {
    margin-right: 0px;
  }
  /* @media (min-width: 800px) { */
  width: 34%;
  max-height: 300px;
  height: 25vw;
  /* } */
  /* height: 40vw; */
  /* width: 100%; */
  position: relative;
`
